import SelfIntro from "../components/homepage/intro";
import Timeline from "../components/homepage/timeline";

export default function Homepage() {
  return (
    <div className="home-columns">
      <SelfIntro />
      <Timeline />
    </div>
  );
}
